module.exports = __webpack_public_path__ + "img/front neck drop.3f9e4cec.png";